const router = [
  {
    path: "/userCenter",
    meta: {
      title: "用户中心"
    },
    component: resolve => require(["../views/userCenter/userCenter"], resolve)
  },
  {
    path: "/auth",
    meta: {
      title: "认证"
    },
    component: resolve => require(["../views/auth/auth"], resolve)
  },
  {
    path: "/publish",
    meta: {
      title: "发布"
    },
    component: resolve => require(["../views/publish/publish"], resolve)
  },
  {
    path: "/businessDetails",
    meta: {
      title: "账户明细"
    },
    component: resolve =>
      require(["../views/businessDetails/businessDetails"], resolve)
  },
  {
    path: "/business",
    meta: {
      title: "账户"
    },
    component: resolve => require(["../views/business/business"], resolve)
  },
  {
    path: "/userAuth",
    meta: {
      title: "认证"
    },
    component: resolve => require(["../views/userAuth/userAuth"], resolve)
  },
  {
    path: "/userbankCard",
    meta: {
      title: "我的银行卡"
    },
    component: resolve =>
      require(["../views/userbankCard/userbankCard"], resolve)
  },
  {
    name: "userBankReplace",
    path: "/userBankReplace",
    meta: {
      title: "更换银行卡"
    },
    component: resolve =>
      require(["../views/userBankReplace/userBankReplace"], resolve)
  },
  {
    path: "/rollOut",
    meta: {
      title: "转出"
    },
    component: resolve => require(["../views/rollOut/rollOut"], resolve)
  },
  {
    path: "/rollIn",
    meta: {
      title: "转入"
    },
    component: resolve => require(["../views/rollIn/rollIn"], resolve)
  },
  {
    path: "/withdrawal",
    meta: {
      title: "提现"
    },
    component: resolve => require(["../views/withdrawal/withdrawal"], resolve)
  },
  {
    path: "/regRecord",
    meta: {
      title: "报名记录"
    },
    component: resolve => require(["../views/regRecord/regRecord"], resolve)
  },
  {
    path: "/baseInfo",
    meta: {
      title: "个人信息"
    },
    component: resolve => require(["../views/baseInfo/baseInfo"], resolve)
  },
  {
    path: '/balance',
    meta: {
      title: '账户余额',
    },
    component: (resolve) => require(['../views/balance/balance'], resolve)
  },

];

export default router;



// WEBPACK FOOTER //
// ./src/router/userCenter.js